import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border-dotted border rounded border-h-neutral-500 flex flex-col text-center items-center justify-center px-[18px] h-[230px] w-full md:h-[200px] mb-10 max-w-[1113px] mx-auto" }
const _hoisted_2 = {
  key: 0,
  class: "h-full py-[30px]"
}
const _hoisted_3 = { class: "mb-2.5" }
const _hoisted_4 = { class: "mb-1 font-extrabold text-h-primary-900" }
const _hoisted_5 = { class: "text-sm h-[15px] text-h-neutral-700" }
const _hoisted_6 = {
  for: "imageFileInput",
  class: "btn-primary cursor-pointer rounded flex items-center justify-center font-bold w-[65px] px-2 py-1.5 mx-auto mb-[21px]"
}
const _hoisted_7 = {
  key: 1,
  class: "w-[140px] h-[140px] rounded relative flex flex-col items-center justify-center border border-h-primary-700 bg-h-neutral-100"
}
const _hoisted_8 = { class: "p-2 text-xs leading-3 text-h-primary-700" }
const _hoisted_9 = { class: "break-all line-clamp-3" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
    (!_ctx.imageSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("forum.topic.form.labels.image")), 1),
            _createElementVNode("small", _hoisted_5, _toDisplayString(_ctx.$t("forum.topic.form.labels.imageRequirements")), 1)
          ]),
          _createVNode(_component_v_icon, {
            name: "md-uploadfile",
            width: "48",
            height: "48",
            class: "mb-2 text-h-neutral-600"
          }),
          _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("forum.topic.form.buttons.imageSend")), 1),
          _createElementVNode("input", {
            type: "file",
            id: "imageFileInput",
            class: "hidden",
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeFile && _ctx.changeFile(...args))),
            accept: "image/*,.jpg,.png,.jpeg,.gif"
          }, null, 32)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_v_icon, {
            name: "md-image-round",
            height: "40px",
            width: "40px",
            class: "text-h-primary-700"
          }),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.imageSelected.name ?? _ctx.$t("labels.generic", {
              pt: "Imagem",
              en: "Image",
            })), 1),
            (_ctx.imageSelected?.mimetype)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "." + _toDisplayString(_ctx.imageSelected?.mimetype), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "rounded-full flex justify-center items-center absolute -top-1.5 -right-1.5 border-4 w-[18px] h-[18px] border-h-primary-700 bg-white",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetImageFile && _ctx.resetImageFile(...args)))
          }, [
            _createVNode(_component_v_icon, {
              name: "md-close",
              width: "10px",
              height: "10px",
              class: "text-h-primary-700"
            })
          ])
        ]))
  ]))
}